import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';

const useStyles = makeStyles((theme) =>({
    input: {
        appearance: 'none',
        background: 'transparent',
        outline: 'none',
        border: 'none',
        color: 'inherit',
        fontSize: theme.typography.fontSize,
        fontWeight: theme.typography.fontWeight,
        height: '50px',
        backgroundColor: 'rgb(0,0,0,.05)',
        lineHeight: 1.5,
        fontFamily: theme.typography.fontFamily,
        width: '100%',
        '&:hover': {
            backgroundColor: 'rgb(0,0,0,.1)',
            cursor: 'pointer'
        },
        '&::-webkit-calendar-picker-indicator':{
            height: '1.5rem',
            width: '1.5rem',
            '&:hover':{
                cursor: 'pointer'
            }
        }
    },

}));
const TimeInput = ({ value, onChange }) => {
    const classes = useStyles();
    return (
        <TimePicker 
            value={value} 
            onChange={onChange} 
            format="HH:mm"    
            disableClock={true}     
            className={classes.input}
        />
    );
};

export default TimeInput;
